module.exports = __webpack_public_path__ + "static/gallery9-3124d9a91ff115f228b3ce75025b1c1c.png";